export class TokenPassword {
  token = null;
  password = null;

  constructor(token, password) {
    this.token = token;
    this.password = password;
  }

  toJSON() {
    return {
      token: this.token,
      password: this.password,
    };
  }
}
